module.exports = __webpack_public_path__ + "img/livemap_editbeacons_childbeaconsexample1.1114eacc.png";